module.exports = __webpack_public_path__ + "img/icon-bullet-warning.1d229b2e.svg";